/* Click chấm màu trên card -> đổi ảnh card sang ảnh variant + link card trỏ tới ?variant=ID.
   Dùng event delegation nên card nào render sau (load more, filter AJAX) vẫn chạy. */
(function () {
  if (window.__wnxCardSwatchesReady) return;
  window.__wnxCardSwatchesReady = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.wnx-swatch');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    card.querySelectorAll('.wnx-swatch.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    swatch.classList.add('is-active');

    // Đổi cả ảnh chính lẫn ảnh hover để rê chuột không nhảy về ảnh slot 2
    var src = swatch.dataset.src;
    if (src) {
      card.querySelectorAll('.card__media img').forEach(function (img) {
        img.src = src;
        if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
        if (swatch.dataset.alt) img.alt = swatch.dataset.alt;
      });
    }

    // Mọi link trong card trỏ về product -> thêm ?variant=ID
    var variantId = swatch.dataset.variantId;
    var productUrl = swatch.closest('.wnx-card-swatches').dataset.productUrl;
    if (!variantId || !productUrl) return;
    card.querySelectorAll('a[href]').forEach(function (a) {
      var path = a.getAttribute('href').split('?')[0];
      if (path === productUrl) a.setAttribute('href', productUrl + '?variant=' + variantId);
    });
  });
})();
